import { BlueLinearGradient } from "../../utils/Utils";

function Button({ children, disabled = false, type, className, onClick }) {
  return (
    <button
      disabled={disabled}
      className={`py-2 md:py-2 px-5 md:px-8 md:text-lg font-bold rounded-full focus:outline-none
      ${
        type == "primary"
          ? `${BlueLinearGradient} text-white  `
          : type == "outline"
          ? " border-[1px] dark:text-white text-primary-black border-primary-blue "
          : "bg-primary-blue text-primary-black "
      }
      ${className}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

export default Button;
